import { PropsWithChildren, ReactNode } from "react";
import { BsFuelPumpFill } from "react-icons/bs";
import { PiClockFill } from "react-icons/pi";

import { cn } from "@bentolabs/kit/utils";

import { Img } from "shared/ui/img";

type Props = {
  title: ReactNode;
  durationDescription?: string;
  className?: string;
  image?: string;
  isActive: boolean;
  onClick: () => void;
  badge?: ReactNode;
};

export const PreviewRow = (props: PropsWithChildren<Props>) => {
  const {
    title,
    durationDescription,
    className,
    badge,
    children,
    image,
    isActive,
    onClick,
  } = props;
  return (
    <div
      className={cn(
        "bg-nobel/5 flex cursor-pointer flex-col gap-y-3 rounded-xl border border-transparent p-3",
        isActive && "border-current/50 bg-current/5",
        className
      )}
      onClick={onClick}
    >
      <div className="flex items-center gap-3.5">
        <Img src={image} className="flex size-10 shrink-0 rounded-full" />
        <div className="flex grow flex-col gap-2">
          <div className="flex items-center gap-1.5 leading-none">
            <span className="inline-flex text-white">{title}</span>
            <span className="text-pink-lemonade inline-flex font-normal">
              (-1.1%)
            </span>
            <div className="ml-auto inline-flex">{badge}</div>
          </div>

          <div className="flex items-center text-sm leading-none">
            <span className="text-nobel/70 mr-auto inline-flex">$95.58</span>
            <span className="text-nobel inline-flex items-center gap-1.5">
              <BsFuelPumpFill className="text-nobel/50" /> $1.27
            </span>
            <span className="text-nobel ml-4 inline-flex items-center gap-1.5">
              <PiClockFill className="text-nobel/50" /> {durationDescription}
            </span>
          </div>
        </div>
      </div>

      {children}
    </div>
  );
};
